import { useState } from 'react'

import {
	EuiButton,
	EuiTable,
	EuiTableHeader,
	EuiTableHeaderCell,
	EuiTableBody,
	EuiTableRow,
	EuiTableRowCell,
} from '@equipmentshare/ds2'

import useCancelReservationHandler from 'views/inventory/effects/cancelReservation'
import { heapEvent } from '@equipmentshare/heaper'
import ReservationTarget from './components/ReservationTarget'
import { ReservationTargetType } from '../../../../../graphql'
import { Reservation } from '../AllocatedPopover'

export enum RowStatus {
	ACTIVE,
	CANCELLING,
	CANCELLED,
}

export type AllocatedTableProps = {
	reservations: Reservation[],
}

export function getInitialRowStatus( reservations: Reservation[] ) {
	const status: { [ key: number ]: RowStatus } = {}

	for ( const r of reservations ) {
		status[ r.reservationId ] = RowStatus.ACTIVE
	}

	return status
}


export default function AllocatedTable( { reservations }: AllocatedTableProps ) {
	const cancelReservation = useCancelReservationHandler( { refetchQueries: [ 'StoreParts' ] } )
	const [ rowStatus, setRowStatus ] = useState( getInitialRowStatus( reservations ) )

	const handleCancel = ( id: number ) => async() => {
		heapEvent( 'Inventory - Inventory Table - Click - Move to Stock', { reservation_id: `${id}` } )
		setRowStatus( {
			...rowStatus,
			[ id ]: RowStatus.CANCELLING,
		} )
		await cancelReservation( id )
		setRowStatus( {
			...rowStatus,
			[ id ]: RowStatus.CANCELLED,
		} )
	}

	return (
		<EuiTable tableLayout="auto">
			<EuiTableHeader>
				<EuiTableHeaderCell>Item is for</EuiTableHeaderCell>
				<EuiTableHeaderCell>Qty</EuiTableHeaderCell>
				<EuiTableHeaderCell />
			</EuiTableHeader>
			<EuiTableBody>
				{ reservations.map( ( r ) => (
					<EuiTableRow key={`allocated-${r.reservationId}`}>
						<EuiTableRowCell><ReservationTarget targetType={r.targetType} targetId={r.targetId} fulfillmentOrder={r.fulfillmentOrder} /></EuiTableRowCell>
						<EuiTableRowCell>{r.quantity}</EuiTableRowCell>
						<EuiTableRowCell>
							{r.targetType !== ReservationTargetType.Order && r.targetType !== ReservationTargetType.FulfillmentOrder && (
								<EuiButton
									color="text"
									size="s"
									isLoading={rowStatus[ r.reservationId ] === RowStatus.CANCELLING}
									isDisabled={rowStatus[ r.reservationId ] !== RowStatus.ACTIVE}
									onClick={handleCancel( r.reservationId )}
								>
									{rowStatus[ r.reservationId ] === RowStatus.ACTIVE ? 'Move to stock'
										: rowStatus[ r.reservationId ] === RowStatus.CANCELLING ? 'Moving...'
											: 'Cancelled'}
								</EuiButton>
							)}
						</EuiTableRowCell>
					</EuiTableRow>
				) )}
			</EuiTableBody>
		</EuiTable>
	)
}
